import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import About from "./pages/about";
import Contact from "./pages/contact";
import Home from "./pages/home";
import Privacy from "./pages/privacy";
import Team from "./pages/team";
import MachineOwnerTerms from "./pages/machine-owner-terms";
import HiringPartyTerms from "./pages/hiring-party-terms";
import AccountDeletion from "./pages/account-deletion";

const App = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/about" component={About} />
      <Route path="/contact" component={Contact} />
      <Route path="/team" component={Team} />
      <Route path="/privacy-policy" component={Privacy} />
      <Route path="/terms-machine-owner" component={MachineOwnerTerms} />
      <Route path="/terms-hiring" component={HiringPartyTerms} />
      <Route path="/account-deletion" component={AccountDeletion} />
    </Switch>
  </BrowserRouter>
);

export default App;
